// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function consultaAreasRequest(): ReducerAction {
	return {
		type: Types.CONSULTA_AREAS_REQUEST,
		payload: null,
	};
}
export function consultaAreasSuccess(payload: object): ReducerAction {
	return {
		type: Types.CONSULTA_AREAS_SUCCESS,
		payload,
	};
}
export function consultaAreasFailure(payload: object): ReducerAction {
	return {
		type: Types.CONSULTA_AREAS_FAILURE,
		payload,
	};
}
export function consultaAreasClear(): ReducerAction {
	return {
		type: Types.CONSULTA_AREAS_CLEAR,
		payload: null,
	};
}
